import { ChevronRightIcon } from '@chakra-ui/icons';
import { LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import NavLink, { NavLinkProps } from '@/components/UI/Links/NavLink';

export const GoToLink = (props: PropsWithChildren<NavLinkProps & ChakraLinkProps>) => {
    const { href, children, ...rest } = props;
    return (
        <NavLink
            href={href}
            variant="boldedBlue"
            role="group"
            _hover={{
                textDecoration: 'none'
            }}
            {...rest}
        >
            {children ? children : <FormattedMessage id="more" />}
            <ChevronRightIcon
                boxSize={4}
                pointerEvents="none"
                transition="transform 200ms ease-in-out"
                _groupHover={{ transform: 'translateX(0.2rem)' }}
            />
        </NavLink>
    );
};
